/**
 * Customer Settings V2 — "Authentication" section: API user
 * management and identity providers via the legacy
 * `CustomerAuthenticationTab`.
 *
 * Contains:
 * - AuthenticationSection (default export)
 */

import LockIcon from '@mui/icons-material/Lock';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SettingsSection } from '@sophocles/views/settings/components';
import CustomerAuthenticationTab from '@sophocles/views/settings/components/CustomerAuthenticationTab';

import { adminOnlyChip } from './chips';

export default function AuthenticationSection(props) {
  const { t } = useTranslation();
  return (
    <SettingsSection
      id="settings-authentication"
      icon={<LockIcon />}
      title={t('userSettings.authentication', 'Authentication')}
      description={t('customerSettings.authenticationDescription', 'API user management and identity providers.')}
      chip={adminOnlyChip(t)}
    >
      <CustomerAuthenticationTab {...props} />
    </SettingsSection>
  );
}
